/**
 * Tunable timing constants and localStorage preservation rules used across
 * the version-watcher modules.
 */

export const POLL_INTERVAL_MS = 60_000;
export const MIN_CHECK_COOLDOWN_MS = 10_000;
export const FETCH_TIMEOUT_MS = 4_000;
export const CLEANUP_CEILING_MS = 1_500;
export const BACKGROUND_THRESHOLD_MS = 5 * 60_000;
export const BACKOFF_STEPS_MS = [60_000, 120_000, 300_000];

/** Grace window so the user actually sees the banner before any auto-reload. */
export const AUTO_RELOAD_BANNER_GRACE_MS = 8_000;

/**
 * While an update is pending and waiting for a safe window, re-evaluate
 * more frequently than the normal poll interval.
 */
export const AUTO_RELOAD_RECHECK_MS = 15_000;

/**
 * iPad/Safari fallback: poll every 2s. iOS throttles/pauses background
 * setTimeout callbacks aggressively (banner tap, scroll bounce, multitask),
 * so the single-shot 8s timer often never fires. An interval-based deadline
 * poller is reliable across visibility flaps.
 */
export const IOS_AUTO_RELOAD_POLL_MS = 2_000;

export const RELOAD_TARGET_KEY = "mblearn_reload_target";
export const RELOAD_TARGET_TTL_MS = 2 * 60_000; // guard expires after 2 minutes
export const POST_RELOAD_FRESH_WINDOW_MS = 30_000;
export const VERSION_RELOAD_GUARD_KEY = "mblearn_last_version_reload_at";
export const VERSION_RELOAD_GUARD_MS = 30 * 60_000;

export const PRESERVE_PREFIXES = ["sb-", "quiz-session-", "app-complete-state", "last_study_point"];

/**
 * `current_session_id` MUST survive a version reload: it's the device-stable
 * identifier that `useSessionManager` validates against `active_sessions`.
 * If we wipe it, the next mount generates a fresh UUID that was never
 * registered server-side → validate returns false → user is wrongly logged
 * out with "Tu cuenta ha sido abierta en otro dispositivo".
 */
export const PRESERVE_EXACT = new Set(["subscription_cache", "current_session_id", "current_session_registered_at", VERSION_RELOAD_GUARD_KEY]);
